import { render, staticRenderFns } from "./ProfileLoading.vue?vue&type=template&id=38376aaa&scoped=true"
import script from "./ProfileLoading.vue?vue&type=script&lang=ts"
export * from "./ProfileLoading.vue?vue&type=script&lang=ts"
import style0 from "./ProfileLoading.vue?vue&type=style&index=0&id=38376aaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38376aaa",
  null
  
)

export default component.exports